import { roundPrice } from "../pricing/round-price";

export const getPriceMinLabel = (min: number): string => {
	if (min === 0) {
		return "";
	}

	let roundedPrice = roundPrice(min);

	if (roundedPrice === 1000) {
		roundedPrice = roundedPrice / 1000;
	}

	let priceText = "";

	if (roundedPrice < 99) {
		if (roundedPrice == 1) {
			priceText += "From &#36;" + roundedPrice + "M";
		} 
		else {
			priceText += "From &#36;" + roundedPrice.toFixed(2) + "M";
		}
	} else {
		priceText += "From the &#36;" + roundedPrice + "s";
	}

	return priceText;
};
